import React from 'react'
// import { Link } from 'react-router-dom'

function SeoServiceDetails() {
    return (
        <div>
            <div className="services-details-area default-padding">
                <div className="cotnainer">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="site-heading text-center">
                                <h4 className="sub-title">Seo Services</h4>
                                <h1 className="title">SEO That Converts Clicks into Customers!</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="services-details-items">
                        <div className="row">
                            <div className="col-xl-12 services-single-content">
                                <div className="thumb mb-50">
                                    <img src="static/img/seo/21.webp" alt="Thumb" title='Application Development' />
                                </div>
                                <p>
                                    At Microcode Software, we are committed to enhancing your business's online visibility and our top SEO strategies help you to achieve new milestones in your industry. As one of the best SEO optimization companies, we have years of expertise to customize your solutions according to your unique needs and goals. We have the SEO specialists for every requirement, whether you are looking for local search engine optimization or want to increase your online store visibility with E-commerce SEO services.
                                </p>
                                <h2>What’s Included in Our SEO Services</h2>
                                <p>Microcode Software provides a complete array of SEO services to boost your online visibility, deliver highly relevant traffic to your website, and grow your business. Here is what's included in our SEO packages:
                                </p>
                                <p>
                                    <strong>SEO Auditing:</strong> We conduct a thorough analysis of your site's technical setup, on-page factors, content, and backlinks to uncover areas of concern and potential opportunities for improvement—part of our professional SEO services in India.
                                </p>
                                <p>
                                    <strong> Keyword Research:</strong> The key feature of top SEO services in India is to identify high-value/low-competition keywords that your target audience is actively searching for to help ensure the content you are creating gets in front of those people when it matters.
                                </p>
                                <p><strong>On-Page SEO:</strong> We will optimize elements of your website such as content, title tags, meta descriptions, headings, internal links, and images to help improve your rankings in search engines as well as help users navigate the site.

                                </p>
                                <p><strong>Off-Page SEO:</strong> Our off-page SEO approaches work to improve your website's authority, trust and relevance across the internet. Each method is tried-and-tested, to create a positive digital footprint that is used as a mechanism to yield higher search engine rankings.</p>
                                <p><strong>Content Creation:</strong> We provide keyword-optimized content such as blog posts, service pages, and product details that speak to your audience while adhering to search engine best practices.
                                </p>
                                <p><strong>Link Building:</strong> We improve your website authority by building high-quality, relevant backlinks from trusted sites that will help elevate your rankings.
                                </p>
                                <p><strong>Technical SEO:</strong> We address many of the critical behind-the-scenes technical aspects, such as mobile responsiveness, site speed, crawlability, structured data, and indexing, which make or break a website's performance in search.
                                </p>
                                <p><strong>Local SEO:</strong> If your business is location-based, we will optimize your website and online listings (such as Google Business Profiles) to help you show up in local searches and maps.
                                </p>
                                <p><strong>Analytics & Reporting:</strong> We will produce regular performance reports using tools like Google Analytics and Search Console to share your traffic, keyword rankings, conversions, and overall SEO ROI.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="services-content bg-gray default-padding">
                <div className="container">
                    <div className="about-style-one-items">
                        <div className="row align-items-center">

                            <div className="col-xl-7 col-lg-6 pl-50 pl-md-15 pl-xs-15">
                                <div className="about-style-one-info">
                                    <div className="content">
                                        <h2 className="title">
                                            Strategic SEO for Transparent Results
                                        </h2>
                                        <p>
                                            Microcode Software offers results-focused SEO based on your business objectives. From technical optimization to local SEO, website content and links - working with our experts will improve your rankings to achieve real growth.  We provide transparent reporting with a personalized touch, making us one of the most trusted providers of top SEO services in India.
                                        </p>
                                        <a class="btn btn-md circle btn-gradient animation mb-20 mb-lg-0" href="/contact" data-discover="true">Contact Us</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <div className="thumb-style-one">
                                    <img src="static/img/seo/2.webp" alt="Img Not Found" title='Application Development' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='services-details-area default-padding'>
                <div className='container'>
                    <div className="process-style-one-items mt-50">
                        <div className="choose-us-one-thumb">
                            <div className="content">
                                <div className="left-info">
                                    <h2 className="title">
                                        Audit to Authority: Transform Your Online Influence
                                    </h2>
                                </div>
                                <div className="process-style-one">
                                    <div className="process-style-one-item">
                                        <span>01</span>
                                        <h4>Discovery & Strategy</h4>
                                        <p>
                                            We review your website and your market to create a custom-built SEO plan to fit your objectives.
                                        </p>
                                    </div>
                                    <div className="process-style-one-item">
                                        <span>02</span>
                                        <h4>Optimization & Implementation</h4>
                                        <p>
                                            We will optimize your website's existing structure, content, and technical elements to increase its rankings.
                                        </p>
                                    </div>
                                    <div className="process-style-one-item">
                                        <span>03</span>
                                        <h4>Growth & Performance</h4>
                                        <p>
                                            We drive your ongoing growth forward with content and backlinks and will track performance.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SeoServiceDetails
